export const options = [
  'Register: the attendance register is up to date.',
  'Planning: weekly reflection and planning notes are completed and filed.',
  'Activities: planning notes are filed and show a variety of small and large group activities are being used.',
  'Child progress: the child progress tools are completed for each child.',
  'Accidents: there is an accident register.',
  'Caregiver meetings: there are attendance registers for the last two monthly caregiver meetings.',
];
